import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";

const fetch = (skip: number, limit: number, filter?: string): AxiosPromise<BaseApiPaging<NotificationApi>> => {
  return api.get<BaseApiPaging<NotificationApi>>(endpoints.NOTIFICATIONS.GET(limit, skip, filter));
};

const getUnreadCount = (category?: number[]): AxiosPromise<number> => {
  return api.get<number>(endpoints.NOTIFICATIONS.GET_UNREAD_COUNT(category));
};

const markAsRead = (id: number): AxiosPromise<void> => {
  return api.post<void>(endpoints.NOTIFICATIONS.MARK_AS_READ(id));
};

const markAllAsRead = (category?: number[]): AxiosPromise<void> => {
  return api.post<void>(endpoints.NOTIFICATIONS.MARK_ALL_AS_READ(category));
};

export const notificationsApi = {
  fetch,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
};

export interface NotificationApi {
  id: number;
  message: string;
  notificationDate: Date;
  isRead: boolean;
  relatedCategoryId?: number;
  relatedCourseGroupId?: number;
  relatedCourseGroupName?: string;
  relatedCourseId?: number;
  relatedUserId?: number;
  relatedTrainerId?: number;
  type: NotificationType;
  category?: NotificationCategory;
}

export const NOTIFICATION_TYPE = {
  COURSE_REGISTERED: 1,
  COURSE_TRANCHE_PAID: 2,
  // EXAM_PAID: 3,
  // SURVEY_FILLED: 4,
  // EXAM_FILLED: 5,
  // ACCOUNT_DELETED: 6,
  // DOCUMENT_GENERATION_FAILED: 7,
  COURSE_CANCELLATION_REQUESTED: 8,
  TRAINER_AVAILABILITY_MARKED: 9,
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE];

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  [NOTIFICATION_TYPE.COURSE_REGISTERED]: "Rejestracja na kurs",
  [NOTIFICATION_TYPE.COURSE_TRANCHE_PAID]: "Płatność za transzę kursu",
  // [NOTIFICATION_TYPE.EXAM_PAID]: "Płatność za egzamin",
  // [NOTIFICATION_TYPE.SURVEY_FILLED]: "Wypełnienie ankiety",
  // [NOTIFICATION_TYPE.EXAM_FILLED]: "Wypełnienie egzaminu",
  // [NOTIFICATION_TYPE.ACCOUNT_DELETED]: "Usunięcie konta",
  [NOTIFICATION_TYPE.COURSE_CANCELLATION_REQUESTED]: "Zgłoszenie rezygnacji z kursu",
  [NOTIFICATION_TYPE.TRAINER_AVAILABILITY_MARKED]: "Oznaczenie dostępności trenera",
};

export const NOTIFICATION_TYPE_OPTIONS: { label: string; value: NotificationType }[] = Object.entries(
  NOTIFICATION_TYPE_LABELS,
).map(([key, label]) => ({
  label,
  value: Number(key) as NotificationType,
}));

export const NOTIFICATION_CATEGORY = {
  COURSES: 1,
  PAYMENTS: 2,
  EXAMS: 3,
  SURVEYS: 4,
  ACCOUNTS: 5,
} as const;

export type NotificationCategory = (typeof NOTIFICATION_CATEGORY)[keyof typeof NOTIFICATION_CATEGORY];
